import { useState } from 'react'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import PropTypes from 'prop-types'
import i18n from 'core/common/i18n'
import { youtubeParser } from 'core/common/utils/regex'
import { Button, Dialog, DialogActions, DialogTitle, Grid } from 'core/components/Core'
import Typography from 'core/components/Typography'
import { DeleteButton, VideoBox } from './styles'

const Video = ({ videoLink, setVideoLink, noDeleteDialog }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <VideoBox>
      <Grid item md={3} xs={12} style={{ position: 'relative' }}>
        <DeleteButton
          disableGutters
          onClick={noDeleteDialog ? setVideoLink : () => setIsOpen(true)}
        >
          <DeleteOutlineIcon fontSize="small" />
        </DeleteButton>
        <iframe
          title="youtubeVideo"
          width="100%"
          src={`https://www.youtube.com/embed/${youtubeParser(videoLink)}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; showinfo"
          allowFullScreen
        />
        <Dialog
          open={isOpen}
          onClose={() => setIsOpen(false)}
          aria-labelledby="delete-video"
          aria-describedby="delete video dialog"
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle disableTypography>
            <Typography fontSize="medium" variant="h5">
              {i18n.t('product.productUpload.deleteConfirmation')}
            </Typography>
          </DialogTitle>
          <DialogActions>
            <Button onClick={() => setIsOpen(false)} color="primary">
              {i18n.t('product.productUpload.close')}
            </Button>
            <Button variant="contained" onClick={setVideoLink} color="primary" autoFocus>
              {i18n.t('product.productUpload.remove')}
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </VideoBox>
  )
}

Video.propTypes = {
  videoLink: PropTypes.string.isRequired,
  setVideoLink: PropTypes.func.isRequired,
}

export default Video
